// eslint-env es6

import { authorize } from 'externalsystems/auth.service';

export function externalAuthenticationRequired({ Parameters: { provider, authtype, command } }) {
    return authorize({ provider: provider, authtype: authtype, context: { command: command } });
}
